import {DomainStore} from 'shared/store';
import {auth, endpoints, types} from 'shared/core';
import _ from 'lodash';
import {action, observable} from 'mobx';
import {hasReviewees} from 'performance/tools';

class RevieweesContainerState extends DomainStore {
  store = new DomainStore();

  @observable pairs;
  @observable checkins;
  @observable isLeader = false;

  @action async load() {
    await this.store._compose([
      endpoints.EMPLOYEES,
      endpoints.PERFORMANCE.REVIEWERS,
      endpoints.PERFORMANCE.CHECKINS,
      endpoints.PERFORMANCE.CYCLES
    ]);
    
    this.pairs = this.store._getAll(types.PERFORMANCE.CHECKIN_RELATIONS);
    this.checkins = _.orderBy(this.store._getAll(types.PERFORMANCE.CHECKIN), ['completedAt', 'createdAt'], ['desc', 'desc']);
    const cycles = this.store._getAll(types.PERFORMANCE.CYCLE);
    this.isLeader = hasReviewees(auth.employee, cycles);
  }
}

export default RevieweesContainerState;
